import { OrbitAvailableIcons } from '../constants.';

interface IconProps {
  name: string;
  size?: number;
  strokeWidth?: number;
  className?: string;
}

export const Icon = ({
  name,
  size = 17,
  className = '',
  strokeWidth = 1,
  ...props
}: IconProps): JSX.Element | null => {
  const OrbitIcon = OrbitAvailableIcons[name];
  return OrbitIcon ? (
    <OrbitIcon {...props} size={size} className={className} strokeWidth={strokeWidth} />
  ) : null;
};
